module.exports = __webpack_public_path__ + "img/button_Solutions.90ad938f.svg";